import React, { useEffect, useCallback, useState} from 'react';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';

const colors = new Colors();

const WIDTH = 300;
const HEIGHT = 100;

const StatsComponent = ({effect, mem, trackStep, trackMem=effect.trackMem, WIDTH=300, HEIGHT=100}) => { 
    let steps = Object.keys(mem).map(parseFloat);
    let values = Object.values(mem).map(parseFloat);
    let maxStep = Math.max(... steps);
    let maxValue = mem.maxTriggers || Math.max(... values);
    let maxLength = effect.maxLength;
    maxStep = 32*(Math.floor(maxStep / 32)+1);

    let minStep = trackStep % maxLength
    let points = steps.map(
        stepNumber =>
            ({
                x:5 + WIDTH*stepNumber/maxStep,
                y: HEIGHT - (5 + HEIGHT*mem[stepNumber]/maxValue)
        }));

    let p ="";

    if (points.length > 0) {
        p = "M " + points[0].x + " " + points[0].y + " L " +
            points.slice(1, maxStep).map(({x,y}) => x + " " + y).join(',');
    } 


    let style = {
        width: WIDTH*((trackStep % maxLength) / maxLength)
    };
    let currentValue = mem[trackStep % maxLength];
    return (
        <div className="stats-effect">
          <div style={style} className="stat-tick">
          </div>
          <div className="stat-number">
            <div>Density: {currentValue}</div>
            <div>Max: {maxValue}</div>
          </div>
          <svg className="stats-drawer" width={WIDTH+10} height={HEIGHT+10}>
            {points.length > 1 && <path className="total-stat" d={p} stroke="red" fill="transparent"/>}
          </svg>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      mem: props.effect.mem,
      trackStep: props.sequencerEngine.trackStep
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StatsComponent);
